import { useTheme } from '@mui/material/styles';
import { claimWeb3InteractionStyles } from './claimWeb3InteractionStyles';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import { useTranslation } from 'react-i18next';
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import Grid from '@mui/material/Grid';
import LinearProgress from '@mui/material/LinearProgress';
import Link from '@mui/material/Link';
import { Web3InteractionStepper } from '../Web3InteractionStepper/Web3InteractionStepper';
import { claimWeb3InteractionSteps } from './claimWeb3InteractionSteps';
import { useSelector } from 'react-redux';
import { useEffect } from 'react';
import { useWeb3Interaction } from '../../hooks/useWeb3Interaction';
import { PATH_OF_ROUTES } from '../../router/routes';
import { useLocation, useNavigate } from 'react-router-dom';
import { ETHER_SCAN_URL } from '../../services/endpoints';
import { Claim } from '../../models/Claim';
import {
  selectUnlockError,
  selectClaim,
  selectVestingContractAddress
} from '../../store/claim/claimSlice';
import { claimDecisions } from './claimWeb3InteractionSpecStrats';

export const ClaimWeb3Interaction = () => {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';
  const classes = claimWeb3InteractionStyles(theme, isDark);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const claim = useSelector(selectClaim);
  const vestingContractAddress = useSelector(selectVestingContractAddress);
  const unlockError = useSelector(selectUnlockError);
  const claimTxHash = claim?.claim?.txHash;
  const { activeStep } = useWeb3Interaction<Claim>(
    claim,
    vestingContractAddress,
    claimDecisions,
    unlockError
  );

  useEffect(() => {
    if (!vestingContractAddress) {
      navigate(PATH_OF_ROUTES.BASE, {
        replace: true,
        state: { from: location }
      });
    }
  }, []);
  return (
    <Grid container justifyContent='center' sx={classes.container}>
      <Paper elevation={3} sx={classes.paperContainer}>
        <Box sx={classes.contentContainer}>
          <Typography variant='h2' sx={classes.title}>
            {t('vesting.home.unlock_web3_interaction.title', {
              roundIndex: vestingContractAddress
            })}
          </Typography>
          <Typography variant='subtitle1' color='secondary'>
            {t('vesting.home.deposit_web3_interaction.subtitle.text')}
          </Typography>
          <Box sx={{ width: 'inherit' }}>
            <Paper variant='outlined' sx={classes.stepContainer}>
              <Typography variant='body1'>
                {t('vesting.home.deposit_web3_interaction.summary')}
              </Typography>
              <Box sx={classes.step}>
                <RadioButtonCheckedIcon color='primary' sx={classes.stepIcon} />
                <Typography variant='body1'>
                  {t(
                    'vesting.home.unlock_web3_interaction.unlock_tx_hash.text'
                  )}
                </Typography>
                {claimTxHash ? (
                  <Link
                    sx={classes.contract}
                    href={`${ETHER_SCAN_URL}/tx/${claimTxHash}`}
                    target='_blank'
                  >
                    {t('vesting.home.deposit_web3_interaction.txHash.link')}
                  </Link>
                ) : (
                  <Box sx={classes.loader}>
                    <LinearProgress />
                  </Box>
                )}
              </Box>
            </Paper>
          </Box>
          <Web3InteractionStepper
            activeStep={activeStep}
            steps={claimWeb3InteractionSteps}
          />
        </Box>
      </Paper>
    </Grid>
  );
};
